var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-aside',{staticClass:"resizable-aside",style:({ width: _vm.asideWidth + 'px' })},[_vm._t("default"),_c('div',{staticClass:"resize-handle",class:{ 'resizing': _vm.isResizing },attrs:{"title":"拖拽调整宽度"},on:{"mousedown":_vm.startResize}},[_c('div',{staticClass:"resize-line"})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }